export const nullError = {
  name: 'No Partner / Company / Wholesaler Selected',
  message: 'Please select a wholesaler and a partner / company.'
}